import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/auth.context";
import { AccountProvider } from "@/contexts/account.context";
import { IntegrationProvider } from "@/contexts/IntegrationContext";
import { FilterProvider } from "@/features/filters/filter.context";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import LoginPage from "@/components/auth/LoginPage";
import RegisterPage from "@/components/auth/RegisterPage";
import ForgotPasswordPage from "@/components/auth/ForgotPasswordPage";
import PlanSelectionPage from "@/components/checkout/PlanSelectionPage";
import CheckoutPage from "@/components/checkout/CheckoutPage";
import TwoFactorPage from "@/components/auth/TwoFactorPage";
import Dashboard from "@/components/Dashboard";
import { configureHeyApiClient } from "@/lib/hey-api-client";
import DebugPage from "./pages/Debug";
import NotFound from "./pages/NotFound";
import { ThemeProvider } from "@/components/theme-provider";

const queryClient = new QueryClient();

configureHeyApiClient();

const AppContent = () => {
  return (
    <AuthProvider>
      <AccountProvider>
        <IntegrationProvider>
          <FilterProvider>
            <Routes>
              {/* Rotas públicas */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/register/plans" element={<PlanSelectionPage />} />
              <Route path="/register/checkout" element={<CheckoutPage />} />
              <Route path="/2fa" element={<TwoFactorPage />} />
              <Route path="/debug" element={<DebugPage />} />

              {/* Redirecionar / para /dashboard */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              {/* Rotas protegidas */}
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard/*" element={<Dashboard />} />
              </Route>

              {/* Página não encontrada */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </FilterProvider>
        </IntegrationProvider>
      </AccountProvider>
    </AuthProvider>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          enableSystem={false}
          disableTransitionOnChange
        >
          <TooltipProvider>
            <AppContent />
            <Toaster />
          </TooltipProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
